import { render, staticRenderFns } from "./tcDetail2.0.vue?vue&type=template&id=bf55c134&scoped=true&"
import script from "./tcDetail2.0.vue?vue&type=script&lang=js&"
export * from "./tcDetail2.0.vue?vue&type=script&lang=js&"
import style0 from "./tcDetail2.0.vue?vue&type=style&index=0&id=bf55c134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf55c134",
  null
  
)

export default component.exports